import { useSearchParams } from 'react-router-dom';
import { IconCalendar } from '../components/Icons';

export function LoginPage() {
  const [params] = useSearchParams();
  // Sätts av /api/auth/elev när en bokmärkt länk inte längre gäller. Utan det
  // här landar eleven bara på Google-knappen och förstår inte varför.
  const badLink = params.get('fel') === 'lank';

  return (
    <div className="login">
      <div className="card login__card">
        <span className="login__mark" aria-hidden="true">
          <IconCalendar size={22} />
        </span>
        <h1 className="login__title">Skolveckan</h1>

        {badLink && (
          <p className="formnote formnote--error login__button" role="status">
            Din inloggningslänk fungerar inte längre. Be läraren om en ny.
          </p>
        )}

        <p className="login__body">
          Logga in med samma Google-konto som skolan använder, så hamnar du i din klass.
        </p>
        <a className="button button--primary login__button" href="/api/auth/google">
          Logga in med Google
        </a>
        <p className="login__hint">
          Om din adress inte har tillgång får du ett meddelande om det — hör då av dig till
          läraren.
        </p>
      </div>
    </div>
  );
}
